import React, { memo, useMemo, ReactNode } from 'react';
import { Document, DocumentProps, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
// CDN WORKER
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface PdfDocumentOwnProps {
  children?: ReactNode;
}

type PdfDocumentProps = PdfDocumentOwnProps & Omit<DocumentProps, 'options'>;

const PdfDocument: React.FC<PdfDocumentProps> = ({ children, ...rest }) => {
  // wrap memo fn !important else we have rerender
  const options = useMemo(() => ({
    cMapUrl: '/cmaps/', // https://github.com/wojtekmaj/react-pdf?tab=readme-ov-file#webpack
    wasmUrl: '/wasm/', // https://github.com/wojtekmaj/react-pdf?tab=readme-ov-file#webpack-1
  }), []);

  return (
    <Document options={options} {...rest}>
      {children}
    </Document>
  );
};

export default memo(PdfDocument);
